<template>
  <section>
    <!--工具条-->
    <el-col :span="4" class="toolbar">
      <el-button type="primary" size="small" @click="addHandler">新增</el-button>
    </el-col>
    <el-col :span="6" class="toolbar rightsearch">
      <el-input placeholder="搜索" size="small" v-model="query" @change="search">
        <el-button slot="append" icon="search" @click="search"></el-button>
      </el-input>
    </el-col>
    <el-table :data="tableData" border v-loading="listLoading">
         <el-table-column label="编号" prop="id" align="center">
      </el-table-column>
      <el-table-column label="标题" prop="title" align="center">
      </el-table-column>
           <el-table-column label="采购时间" prop="create_time" align="center">
      </el-table-column>
           <el-table-column label="采购内容" prop="content" align="center">
      </el-table-column>
           <el-table-column label="备注" prop="remark" align="center">
      </el-table-column>
      <el-table-column label="操作" prop="labels" align="center">
        <template scope="scope">
          <el-button size="small" type="primary"  @click="editHandler(scope.row)">修改</el-button>
          <el-button v-if="scope.row.status == 0" size="small" type="primary"  @click="deleteHandler(scope.row)">删除</el-button>

           <el-button v-if="scope.row.status == 1"  size="small" type="primary" @click="deleteHandler(scope.row)">恢复</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog title="新增" v-model="addFormVisible">
      <el-form :model="addForm" label-width="150px" :rules="formRules" ref="addForm">
        <el-form-item label="标题" prop="title">
          <el-input v-model="addForm.title" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
            <el-date-picker
            v-model="addForm.create_time"
            type="datetime"
            placeholder="选择创建时间"
            size="small"
            format="yyyy-MM-dd">
            </el-date-picker> 
        </el-form-item>
         <el-form-item label="内容">
            <el-input type="textarea" v-model="addForm.content"></el-input>
        </el-form-item>
         <el-form-item label="备注">
            <el-input type="textarea" v-model="addForm.remark"></el-input>
        </el-form-item>
 </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="addSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" v-model="editFormVisible">
      <el-form :model="editForm" label-width="150px" :rules="formRules" ref="editForm">
   
               <el-form-item label="标题" prop="title">
          <el-input v-model="editForm.title" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
            <el-date-picker
            v-model="editForm.create_time"
            type="datetime"
            placeholder="选择创建时间"
            size="small"
            format="yyyy-MM-dd">
            </el-date-picker> 
        </el-form-item>
         <el-form-item label="内容">
            <el-input type="textarea" v-model="editForm.content"></el-input>
        </el-form-item>
         <el-form-item label="备注">
            <el-input type="textarea" v-model="editForm.remark"></el-input>
        </el-form-item>




      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="editSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import config from '../../config';
  import {
    getQiniuToken
  } from '../../static/js/token.js'
  import {
    formatDate
  } from '../../static/js/date.js';
  import basicdata from '../../static/config/basicdata.js';

  export default {
    data() {
      return {
        tableData: [],
        total: 0,
        page: 1,
        pageSize: 15,
        listLoading: false,
        query: '',
        submitLoading: false,
        addFormVisible: false,
         addForm: {
          id: 0,
          title: '',
          content: '',
          create_time: '',
          remark: '',
          status: 0
        },
        editFormVisible: false,
        editForm: {},
        formRules: {},
        showUploadList: false,
        uploadForm: {
          token: getQiniuToken(),
          key: null
        },
        imageUrl: '',
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getSearch(this.query);
      },
      getSearch(query) {
        this.listLoading = true;
        this.$axios.post(config.api_url + '/procure/page', {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if (data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'warning'
          });
        })
      },
      addSubmit() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = Object.assign({}, this.addForm);
              //异步请求
              this.$axios.post(config.api_url + '/procure',
                para).then(response => {
                if (response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['addForm'].resetFields();
                  this.addFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      //操作删除
      deleteHandler(row) {
      let text = '是否删除？';
        let status = 1;
        if(row.status == 1) {
          text = '是否恢复？'
          status = 0
        }

          this.$confirm(text, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$axios.delete(config.api_url + '/procure/delete/' + row.id + '/' + status).then(response => {
              if (response.data.state) {
                 this.$message({
                message: '操作成功',
                type: 'success'
              });
                this.search();
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                });
              }
            }).catch(error => {
              this.$message({
                message: '删除异常，请联系管理员',
                type: 'error'
              });
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
       
      },
      //修改数据弹框
      editHandler(row) {
        this.editFormVisible = true;
        this.editForm = row
        this.imageUrl = row.pic;
      },
      editSubmit() {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = Object.assign({}, this.editForm);
              //异步请求
              this.$axios.put(config.api_url + '/procure',
                para).then(response => {
                if (response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['editForm'].resetFields();
                  this.editFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      addHandler() {
        this.addFormVisible = true;
      },

    },
    created() {
      this.search();
    }
  }
</script>

<style scoped>
  .rightsearch {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// index.vue?5963b907